import React from 'react'
import { SearchFilterRelevanceCTAs } from '../../components/filters-cta/filters-cta'
import { useSearchViewState } from '../../contexts/search-view-state-context'
import { useDelayUnmount } from '../../hooks/use-delay-unmount'
import { PortalAndModal } from '../../components/portal-and-modal/portal-and-modal'
import { useRetailerStockSearch } from '../../utils/retailer-stock'
import { SearchForm } from '../../forms/search-form/search-form'
import { ResultsCountAndSaveSearchSection } from './results-count-and-save-search'
import { useForm } from '../../forms/hocs/form.context'
import { SkeletonPills } from '../../pages/pills-skeleton'
import { SkeletonResultsCountAndSaveSearchSection } from '../../pages/search-results/restults-count-and-save-search-skeleton'

export const SearchFacets = () => {
    const { showSearchFilter } = useSearchViewState()
    const [isRetailerStockSearch] = useRetailerStockSearch()
    const delay = 400
    const shouldRenderChild = useDelayUnmount(showSearchFilter, delay)
    const { loading } = useForm()

    return (
        <>
            {loading ? (
                <>
                    <SkeletonPills />
                    <SkeletonResultsCountAndSaveSearchSection />
                </>
            ) : (
                <>
                    <SearchFilterRelevanceCTAs />
                    {!isRetailerStockSearch ? <ResultsCountAndSaveSearchSection /> : null}{' '}
                </>
            )}
            <PortalAndModal showChildren={shouldRenderChild}>
                <SearchForm />
            </PortalAndModal>
        </>
    )
}
